module.exports = __webpack_public_path__ + "static/media/super-hit.25148e89.png";